module.exports = __webpack_public_path__ + "static/img/third1_6_active.1e48302a.png";